// extracted by mini-css-extract-plugin
export default {"LoadError":"bez_a bhm_qs bhm_a bhm_w bhm_j bhm_q","LoadError__icon":"bez_b bhm_vl bhm_fm bhm_sw","LoadError__message":"bez_c bhm_fm bhm_tr"};